


























import {
  defineComponent,
  computed,
  ref,
  watch,
  useRoute,
  useFetch,
  onMounted,
  onBeforeMount,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import { PAGE_NS, PageState } from '~/store/modules/shared/page/state'
import AppHeader from '~/components/car/header/AppHeader.vue'
import AppBottomMenu from '~/components/car/header/AppBottomMenu.vue'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { PARKING_NS, ParkingState } from '~/store/modules/shared/parking/state'
import AppFooter from '~/components/car/footer/AppFooter.vue'
import LanguageSwitcher from '~/services/LanguageSwitcher'
import FlashService from '~/services/flash/FlashService'
import AdmanAdsService from '~/services/ads/AdmanAdsService'
import { useNamespacedStore } from '~/compositions/store'
import { useDeps } from '~/compositions/dependency-container'
import AppNotifications from '~/components/shared/configurable/notification-center/AppNotifications.vue'
import AppConfirmationModal from '~/components/shared/configurable/modal/AppConfirmationModal.vue'
import AppGlobalAlerts from '~/components/car/AppGlobalAlerts.vue'
import AppSnackbar from '~/components/car/AppSnackbar.vue'
import GoogleOneTap from '~/components/shared/social-login/GoogleOneTap.vue'
import AppRogueClassifiedsModal from '~/components/shared/configurable/modal/AppRogueClassifiedsModal.vue'
import { useGlobalElements } from '~/compositions/global-elements'

export default defineComponent({
  components: {
    AppRogueClassifiedsModal,
    GoogleOneTap,
    AppSnackbar,
    AppNotifications,
    AppFooter,
    ParkingModal: defineVue3AsyncComponent(() =>
      import('~/components/shared/parking/ParkingModal.vue')
    ),
    CLoginModal: defineVue3AsyncComponent(() =>
      import('~/components/shared/login/CLoginModal.vue')
    ),
    AppHeader,
    AppBottomMenu,
    AppConfirmationModal,
    AppGlobalAlerts
  },
  setup() {
    const route = useRoute()
    const {
      isIframe,
      showMobileBottomMenu,
      isSubdomain,
      showParking,
      showFooter,
      showHeader,
      showGoogleOneTap,
      showGlobalAlerts,
      inMap,
      isLoginModalVisible
    } = useGlobalElements()

    const [languageSwitcherService, admanAdsService, flashService] = useDeps(
      LanguageSwitcher,
      AdmanAdsService,
      FlashService
    )

    const { state: classifiedSearchState } = useNamespacedStore<SearchState>(
      CLASSIFIED_SEARCH_NS
    )
    const { dispatch: pageDispatch } = useNamespacedStore<PageState>(PAGE_NS)
    const { dispatch: parkingDispatch } = useNamespacedStore<ParkingState>(
      PARKING_NS
    )

    const availableLocales = ref(languageSwitcherService.getAvailableLocales())

    useFetch(() => {
      if (isIframe.value) {
        pageDispatch('addBodyClass', 'iframe')
      }
      if (isSubdomain.value) {
        pageDispatch('addBodyClass', 'subdomain')
      }
    })

    const currentRoute = computed(() => classifiedSearchState.currentRoute)

    onBeforeMount(() => {
      flashService.setClientFlashFromCookie()
    })

    onMounted(() => {
      window.history.scrollRestoration = 'auto'
    })

    watch(currentRoute, val => {
      availableLocales.value = languageSwitcherService.getAvailableLocales(val)
    })

    watch(route, val => {
      availableLocales.value = languageSwitcherService.getAvailableLocales()
      if (process.client) {
        admanAdsService.refreshInnovativeFormats(val)
      }
    })

    function hideParkingModal() {
      parkingDispatch('hideParking')
    }

    return {
      currentRoute,
      showParking,
      availableLocales,
      isIframe,
      isSubdomain,
      hideParkingModal,
      showFooter,
      showHeader,
      showGoogleOneTap,
      showGlobalAlerts,
      inMap,
      isLoginModalVisible,
      showMobileBottomMenu
    }
  },
  head() {
    const { bodyClasses } = this.$store.state.page
    return {
      bodyAttrs: {
        class: bodyClasses.join(' ')
      }
    }
  }
})
